import { Link, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';

import { useMarketPlaceProductIdFromUrl } from '@features/marketplace/navigation/useMarketPlaceProductIdFromUrl';
import { useGetMarketPlaceProduct } from 'hooks/useGetMarketPlaceProduct';
import { NavigationEntity, useIsMarketplaceNavidationSelected } from 'hooks/useNavigationEntities';

const NavigationLinkItem = ({ entity }: { entity: NavigationEntity }) => {
  const isSelected = useIsMarketplaceNavidationSelected(entity);
  const productId = useMarketPlaceProductIdFromUrl();
  const selectedProduct = useGetMarketPlaceProduct(productId);
  const router = useRouter();

  const onClick = useCallback(() => {
    if (entity.absolutePath != null && (!isSelected || selectedProduct != null)) {
      router.push(entity.absolutePath);
    }
  }, [entity, router, isSelected, selectedProduct]);

  useEffect(() => {
    const path = entity.absolutePath;
    if (path != null) {
      router.prefetch(path);
    }
  }, [entity, router]);

  return (
    <Link variant={isSelected ? 'underline' : 'plain'} onClick={onClick}>
      <Text fontSize={isSelected ? 'lg' : 'sm'}>{entity.name}</Text>
    </Link>
  );
};

export default observer(NavigationLinkItem);
